module.exports = __webpack_public_path__ + "img/skm.2e3b7024.png";